<template>
	<div>
		<div class="backImg max-contain"></div>
		<div class="content">
			<div class="top">
				<el-carousel height="700px">
					<el-carousel-item v-for="item in bannerList" :key="item">
						<el-image :src="item.img" alt="" fit="cover" style="width: 100%;" />
					</el-carousel-item>
				</el-carousel>
			</div>
			<div id="our_products">
				<div class="grid-container container grid-parent swaporder">
					<div class="first-column">
						<h4>Our Products</h4>
						<h1>Consistently delivering delicious, nutritious and healthy seafood</h1>
						<p>
							Thanks to our world-leading, innovative and sustainable approach, we offer a wide selection of healthy, delicious and
							responsibly produced seafood.
						</p>
						<div class="mowilink" @click="handleClick('/about')">About our brands and products</div>
					</div>
					<div class="second-column">
						<img src="../assets/index/product.jpg" alt="" srcset="" />
					</div>
				</div>
			</div>
			<div class="main">
				<div class="main-business-scope">
					<div class="second-column" style="color: #fff;">
						<h1>Join the Blue Revolution</h1>
						<p>
							At norja, people are the core of our business. With over 14 500 employees, we are the world's largest salmon farming company
							and are always on the lookout for driven, ambitious and forward-thinking people to come and join our team.
						</p>
						<div class="mowilink" @click="handleClick('/connect')">Work with us</div>
					</div>
				</div>
				<div class="main-number-info">
					<div
						:class="{ 'main-number-info-item': true, 'end-item': index === 2, 'middle-item': index == 1 }"
						v-for="(item, index) in infoList"
						:key="index"
					>
						<img :src="item.img" alt="" />
						<div class="title">
							{{ item.title }}
						</div>
						<p class="desc">
							{{ item.desc }}
						</p>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>
<script>
export default {
	name: 'Index',
	data() {
		return {
			bannerList: [
				{
					img: require('../assets/index/页面_1.1.png'),
				},
				{
					img: require('../assets/index/页面_1.2.png'),
				},
				{
					img: require('../assets/index/页面_1.3.png'),
				},
				{
					img: require('../assets/index/页面_1.4.png'),
				},
			],
			infoList: [
				{
					img: require('../assets/index/海洋.png'),
					title: 'The Potential',
					desc:
						'The ocean is key to ensuring the planet has enough food – yet only 2% of the world’s current food supply comes from the ocean.',
				},
				{
					img: require('../assets/index/三文鱼寿司.png'),
					title: 'Footprint',
					desc:
						'With a uniquely low carbon footprint, aquaculture has the potential to play an ever more relevant role in providing food to a growing world population.',
				},
				{
					img: require('../assets/index/鱼.png'),
					title: 'Healthy Diet',
					desc:
						'Salmon can play a key role in a healthy diet: not only is it packed with high-quality protein, it is also a rich source of omega-3 and vitamins and minerals. ',
				},
				{
					img: require('../assets/index/渔业.png'),
					title: 'Animal Welfare',
					desc:
						'Our approach to fish welfare and health is second to none. We take pride and great care in rearing our fish to the highest standards possible.',
				},
			],
			serviceInfo: [
				{
					name: '空运代理',
					desc: '团队超过十年以上国际空运行业经验,擅长提供量身定制的运输服务',
				},
				{
					name: '仓储服务',
					desc: '在东莞、广州、义乌、肇庆，深圳等地开设有运营仓库，占地面积将近36000㎡',
				},
				{
					name: '国内运输',
					desc: '专业车队，随时为客户提供到厂提货,和派送服务',
				},
			],
		};
	},
	methods: {
		handleClick(path) {
			this.$router.push({ path });
		},
	},
	mounted() {},
	computed: {},
};
</script>
<style lang="less" scoped>
.top {
	height: 700px;
	width: 100%;
	margin-top: 100px;
	img {
		width: 100%;
	}
}
.second-column {
	float: right;
	text-align: right;
	width: 50%;
	img {
		height: auto;
		max-width: 100%;
	}
}
.mowilink {
	display: block;
	text-transform: uppercase;
	color: #f26551;
	font-family: 'century-gothic', 'CenturyGothic', 'AppleGothic', sans-serif;
	font-weight: 900;
	font-size: 12px;
	letter-spacing: 1.8px;
	margin-top: 30px;
	cursor: pointer;
}
#our_products {
	background: #fff;
	padding: 50px 0 40px;
	width: 100%;
	.grid-container {
		clear: both;
		overflow: hidden;
		// max-width: 968px;
	}
	.first-column {
		width: 35%;
		float: left;
		padding: 15px 40px 0 0;
		font-family: 'century-gothic', 'CenturyGothic', 'AppleGothic', sans-serif;
		h1 {
			font-weight: 700;
			color: #404041;
			margin-bottom: 25px;
			line-height: 43px;
		}
		p {
			font-size: 15px;
			color: #404041;
			line-height: 26px;
		}
	}
}
.line-dec {
	height: 40px;
	line-height: 40px;
	text-align: center;
	font-size: 12px;
	position: relative;

	&::before {
		content: '';
		position: absolute;
		left: 20px;
		top: 19px;
		z-index: 1;
		background-color: #ddd;
		width: 40%;
		height: 0.5px;
	}

	&::after {
		content: '';
		position: absolute;
		right: 20px;
		top: 19px;
		z-index: 1;
		background-color: #ddd;
		width: 40%;
		height: 0.5px;
	}
}
.main-number-info {
	padding: 60px 0px;
	display: flex;
	justify-content: space-evenly;
	background: #f6f6f6;

	.main-number-info-item {
		// height: 290px;
		width: 222px;
		display: flex;
		align-items: center;
		flex-direction: column;
		justify-content: space-between;
		font-family: 'century-gothic', 'CenturyGothic', 'AppleGothic', sans-serif;
		color: #404041;
		img {
			width: 85px;
			height: 64px;
			object-fit: contain;
		}
		.title {
			font-weight: 700;
			font-size: 18px;
			padding: 15px 0;
		}

		.desc {
			font-size: 14px;
			line-height: 22px;
			text-align: center;
		}
	}
	.end-item {
		.line {
			left: 74px !important;
		}
	}
	.middle-item {
		.line {
			left: 69px !important;
		}
	}
}

.main-business-scope {
	background-image: url('../assets/index/Beitveitnes-9-e1552391353694.jpg');
	background-size: fill;
	background-position: center;
	background-repeat: no-repeat;
	width: 100%;
	height: 500px;
	display: flex;
	align-items: center;
	justify-content: flex-end;
	.second-column {
		width: 40%;
		padding: 0 20px;
	}
	h1 {
		line-height: 43px;
		margin-bottom: 12px;
	}
	p {
		font-family: 'century-gothic', 'CenturyGothic', 'AppleGothic', sans-serif;
		font-size: 15px;
		line-height: 26px;
	}
}

.main-characteristic-service {
	background: rgba(0, 0, 0, 0.5);
	height: 552px;
	width: 100%;
	padding-top: 50px;
	box-sizing: border-box;
	color: #fff;

	.el-divider__text {
		background: rgba(0, 0, 0, 0.5);
		color: #fff;
	}

	.title {
		font-size: 24px;
		text-align: center;
	}

	.text {
		display: flex;
		justify-content: space-evenly;
		margin-top: 100px;
	}

	.text-item {
		width: 280px;
		height: 170px;
		padding: 0 15px;
		background: rgba(255, 255, 255, 0.3);
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		font-size: 14px;
		text-align: center;
		line-height: 30px;

		.name {
			font-size: 20px;
			font-weight: 500;
			margin-bottom: 10px;
		}

		&:hover {
			background-color: rgba(0, 0, 0, 0.5);
			// opacity: 0.5;
			cursor: pointer;
			border-bottom: 2px solid #3399ff;
		}
	}
}
</style>
